import { render } from "./FakeWaveForm.vue?vue&type=template&id=f1b2f96c&scoped=true&lang=html"
import script from "./FakeWaveForm.vue?vue&type=script&lang=js"
export * from "./FakeWaveForm.vue?vue&type=script&lang=js"

import "./FakeWaveForm.vue?vue&type=style&index=0&id=f1b2f96c&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-f1b2f96c"

export default script